import { api } from './client.js';

export const analyticsApi = {
  // Returns { range, totals, daily[], top_pages[], top_referrers[], top_devices[] }.
  // `days` is clamped to [1, 180] server-side; defaults to 30.
  forSite: (siteId, days = 30) =>
    api
      .get(`/sites/${siteId}/analytics`, { params: { days } })
      .then((r) => r.data),
};
